/* ---- CC shared cart state (Sep 29 2026) ----------------------------------
 * The same block sits at the top of cc-fast-cart.js, cc-delivery.js and
 * cc-gift.js; whichever loads first installs it, the others reuse it.
 *   - ONE /cart.js download shared by every cart script (no duplicates).
 *   - Carts returned by /cart/change|update|clear are reused, not re-downloaded.
 *   - Any cart write marks the copy stale, so nobody ever reads an old cart.
 *   - preview(): the cart as the customer expects it right now (taps not yet
 *     saved). Used ONLY to repaint numbers instantly; never to act on.
 * ------------------------------------------------------------------------ */
(function () {
  if (window.ccCart) { return; }
  var nf = window.fetch;
  if (!nf) { return; }
  var MUT = /\/cart\/(add|change|update|clear)/;
  var last = null, lastAt = 0, stale = true, pending = 0, ver = 0, inflight = null;
  var subs = [], psubs = [];

  function isCart(c) { return c && c.items && typeof c.total_price === 'number'; }
  function emit(list, c) { list.forEach(function (fn) { try { fn(c); } catch (e) {} }); }

  function set(c) {
    if (!isCart(c)) { return; }
    last = c; lastAt = Date.now();
    if (pending === 0) { stale = false; }
    emit(subs, c);
  }

  function get(maxAge) {
    if (!stale && pending === 0 && last && maxAge && Date.now() - lastAt < maxAge) {
      return Promise.resolve(last);
    }
    if (inflight) { return inflight; }
    var v = ver;
    inflight = nf.call(window, '/cart.js?t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        inflight = null;
        if (v === ver && pending === 0) { set(c); }
        return c;
      }, function (e) { inflight = null; throw e; });
    return inflight;
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : ((input && input.url) || '');
    var mut = MUT.test(url);
    if (mut) { ver++; pending++; stale = true; }
    var p = nf.apply(window, arguments);
    if (mut) {
      p.then(function (r) {
        pending = Math.max(0, pending - 1);
        if (!r.ok || /\/cart\/add/.test(url)) { stale = true; return; }
        var ct = (r.headers && r.headers.get('content-type')) || '';
        if (ct.indexOf('json') === -1) { stale = true; return; }
        r.clone().json().then(set).catch(function () { stale = true; });
      }, function () { pending = Math.max(0, pending - 1); stale = true; });
    }
    return p;
  };

  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (typeof u === 'string' && MUT.test(u)) {
      ver++; pending++; stale = true;
      this.addEventListener('loadend', function () { pending = Math.max(0, pending - 1); stale = true; });
    }
    return xo.apply(this, arguments);
  };

  window.ccCart = {
    get: get,
    last: function () { return last; },
    /* the cart only if it is known to be current (no write since it arrived) */
    fresh: function () { return (!stale && pending === 0) ? last : null; },
    on: function (fn) { subs.push(fn); },
    onPreview: function (fn) { psubs.push(fn); },
    preview: function (c) { if (isCart(c)) { emit(psubs, c); } }
  };
}());

/*  Classic Ceramics - free gifts in the cart (two tiers)
 *
 *  Goods in the cart (excluding gift lines):
 *    Rs 5,000 - 9,999  : FREE Mystery Mug  (gift-only product, Rs 720, tag free-gift)
 *    Rs 10,000+        : FREE Loop Vase (gift-only product "Loop Vase - Free Gift", tag free-gift,
 *                        Rs 2,000) - mug swapped out
 *  Sep 29: both gifts are UNLISTED gift-only products made free by ONE automatic
 *  "amount off products" 100% discount that covers only those two products, with a
 *  page that has no buy buttons (template product.gift). That discount never touches
 *  the customer's other items - the old "Buy X Get Y" discounts did, and made Shopify
 *  split them into two lines of the same product.
 *  Gift lines carry the hidden property _free_gift = 'mug' | 'vase'.
 *  A line is a gift if its VARIANT is a gift variant. Any gift variant line is
 *  removed when the cart does not qualify, so a gift cannot be taken on its
 *  own. Any OTHER line still tagged _free_gift (e.g. the Rs 2,000 vase the old
 *  setup used as the gift) is removed, so nobody is charged for an old gift line.
 *  Only one gift per order. If a customer removes a gift by hand it is not
 *  forced back (this session).
 */
(function () {
  'use strict';

  var MUG  = { tier: 'mug',  variant: 67587184558309, min: 5000,  max: 10000, name: 'Mystery Mug' };
  var VASE = { tier: 'vase', variant: 67588090790117, min: 10000, max: Infinity, name: 'Loop Vase', worth: 'Rs 2,000' };
  var TIERS = [MUG, VASE];
  var PROP = '_free_gift';
  var GIFT_TIER = {};
  GIFT_TIER[MUG.variant] = 'mug';
  GIFT_TIER[VASE.variant] = 'vase';

  function money(r) { return 'Rs ' + Math.round(r).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function okey(t) { return 'ccGiftRemoved_' + t.tier; }
  function optedOut(t) { try { return sessionStorage.getItem(okey(t)) === '1'; } catch (e) { return false; } }
  function setOptOut(t, v) { try { if (v) { sessionStorage.setItem(okey(t), '1'); } else { sessionStorage.removeItem(okey(t)); } } catch (e) {} }

  var soldOut = { mug: false, vase: false };

  function tierFor(goods) {
    for (var i = 0; i < TIERS.length; i++) { if (goods >= TIERS[i].min && goods < TIERS[i].max) { return TIERS[i]; } }
    return null;
  }

  function summarise(cart) {
    var goods = 0, lines = [];
    (cart.items || []).forEach(function (it) {
      var gt = GIFT_TIER[it.variant_id];
      if (gt) { lines.push({ key: it.key, tier: gt, qty: it.quantity }); return; }
      var tag = it.properties && it.properties[PROP];
      if (tag) { lines.push({ key: it.key, tier: 'old', qty: it.quantity }); return; }
      goods += (it.final_line_price || it.line_price || 0) / 100;
    });
    return { goods: goods, lines: lines, count: cart.item_count || 0 };
  }

  /* ---------- message box ---------- */
  function injectStyle() {
    if (document.getElementById('CCGiftStyle')) { return; }
    var s = document.createElement('style');
    s.id = 'CCGiftStyle';
    s.textContent =
      '.cc-gift{margin:0 0 12px;padding:11px 14px;border:1px solid #e3e3e3;border-left:3px solid #2f2f2f;' +
      'background:#f7f7f5;border-radius:3px;font-size:13px;line-height:1.5;color:#1c1c1c;text-align:left;}' +
      '.cc-gift--won{background:#f0f6f0;border-color:#d5e6d6;border-left-color:#2e6b34;}' +
      '.cc-gift b{font-weight:700;}' +
      '.cc-gift-sub{display:block;margin-top:4px;font-size:12px;color:#444;}' +
      '.cc-gift-bar{margin-top:8px;height:5px;border-radius:3px;background:#e2e2de;overflow:hidden;}' +
      '.cc-gift-bar span{display:block;height:100%;background:#2f2f2f;transition:width .35s ease;}';
    document.head.appendChild(s);
  }

  var ANCHORS = ['.cart__page-col .cart__checkout-wrapper', '.drawer__footer .cart__checkout-wrapper', '.ajaxcart__subtotal'];
  function anchor() {
    for (var i = 0; i < ANCHORS.length; i++) {
      var all = document.querySelectorAll(ANCHORS[i]);
      for (var j = 0; j < all.length; j++) { if (all[j].offsetParent !== null) { return all[j]; } }
    }
    return null;
  }

  function bar(g, target) {
    var pct = Math.max(0, Math.min(100, g / target * 100));
    return '<div class="cc-gift-bar"><span style="width:' + pct.toFixed(1) + '%"></span></div>';
  }

  function render(sum, hasTier) {
    var box = document.querySelector('.cc-gift');
    var spot = anchor();
    if (!spot || sum.count === 0) { if (box) { box.remove(); } return; }
    injectStyle();
    if (!box) { box = document.createElement('div'); box.className = 'cc-gift'; }
    var deliv = spot.parentNode.querySelector('.cc-deliv');
    var before = deliv && deliv.parentNode === spot.parentNode ? deliv : spot;
    if (box.nextSibling !== before) { spot.parentNode.insertBefore(box, before); }

    var g = sum.goods;
    var vaseLine = '🎁 Add <b>' + money(VASE.min - g) + '</b> more and get a <b>FREE ' + VASE.name + '</b> (worth ' + VASE.worth + ')';

    if (g >= VASE.min) {
      if (soldOut.vase) { box.remove(); return; }
      box.className = 'cc-gift cc-gift--won';
      box.innerHTML = '🎁 <b>FREE ' + VASE.name + '</b> (worth ' + VASE.worth + ')' + (hasTier === 'vase' ? ' added to your order!' : ' on this order.');
    } else if (g >= MUG.min) {
      box.className = 'cc-gift cc-gift--won';
      var top = soldOut.mug ? '' : '🎁 <b>FREE ' + MUG.name + '</b>' + (hasTier === 'mug' ? ' added to your order!' : ' on this order.');
      var up = soldOut.vase ? '' : (soldOut.mug ? vaseLine : '<span class="cc-gift-sub">Add <b>' + money(VASE.min - g) +
        '</b> more to upgrade to a <b>FREE ' + VASE.name + '</b> (worth ' + VASE.worth + ')</span>');
      if (!top && !up) { box.remove(); return; }
      box.innerHTML = top + up + (soldOut.vase ? '' : bar(g, VASE.min));
    } else {
      if (soldOut.mug) {
        if (soldOut.vase) { box.remove(); return; }
        box.className = 'cc-gift';
        box.innerHTML = vaseLine + bar(g, VASE.min);
        return;
      }
      box.className = 'cc-gift';
      box.innerHTML = '🎁 Add <b>' + money(MUG.min - g) + '</b> more and get a <b>FREE ' + MUG.name + '</b>' + bar(g, MUG.min);
    }
  }

  /* ---------- cart actions ---------- */
  var busy = false, again = false, lastHad = { mug: false, vase: false }, ours = false;

  function refreshThemeCart() {
    /* Sep 30: the theme redraws the cart page AND the drawer on this event -
       the old full page reload on /cart took ~2 s and is gone. */
    document.dispatchEvent(new CustomEvent('cart:build'));
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }

  function check(maxAge) {
    if (busy) { again = true; return; }
    busy = true;
    var load = window.ccCart ? window.ccCart.get(maxAge || 0) :
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    load
      .then(function (cart) {
        var sum = summarise(cart);
        var tier = tierFor(sum.goods);
        var has = {
          mug: sum.lines.some(function (l) { return l.tier === 'mug'; }),
          vase: sum.lines.some(function (l) { return l.tier === 'vase'; })
        };

        /* a gift vanished without us removing it while its tier still applied = customer removed it */
        TIERS.forEach(function (t) {
          if (!ours && lastHad[t.tier] && !has[t.tier] && tier === t) { setOptOut(t, true); }
          if (tier !== t) { setOptOut(t, false); }
          lastHad[t.tier] = has[t.tier];
        });
        ours = false;

        var want = tier && !soldOut[tier.tier] && !optedOut(tier) ? tier : null;

        /* keep at most one line of the wanted gift at qty 1; remove every other gift line */
        var updates = {}, needUpdate = false, keep = null;
        sum.lines.forEach(function (l) {
          if (want && l.tier === want.tier && !keep) { keep = l; if (l.qty !== 1) { updates[l.key] = 1; needUpdate = true; } }
          else { updates[l.key] = 0; needUpdate = true; }
        });

        var shown = livePv();
        if (shown) { var ps = summarise(shown); render(ps, giftTierOf(ps)); }
        else { render(sum, keep ? keep.tier : null); }

        if (needUpdate) {
          ours = true;
          return post('/cart/update.js', { updates: updates })
            .then(function (r) { return r.clone().json(); })
            .then(function (c) {
              /* Sep 30: removing the gift emptied the cart page - show the empty page */
              if (c && c.item_count === 0 && document.getElementById('CartPageForm')) { window.location.reload(); return; }
              refreshThemeCart();
            }, refreshThemeCart);
        }
        if (want && !keep) {
          var props = {}; props[PROP] = want.tier;
          ours = true;
          return post('/cart/add.js', { items: [{ id: want.variant, quantity: 1, properties: props }] })
            .then(function (r) {
              if (!r.ok) { soldOut[want.tier] = true; ours = false; render(sum, null); return; }
              refreshThemeCart();
            });
        }
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; schedule(); }
      });
  }

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(function () { check(3000); }, 400); }

  /* Sep 29: the gift message follows the cart on the tap (preview = paint
     only, never add/remove), and gift decisions run the moment Shopify
     answers, from the cart it returned - no extra download. */
  function giftTierOf(sum) {
    for (var i = 0; i < sum.lines.length; i++) {
      if (sum.lines[i].tier === 'mug' || sum.lines[i].tier === 'vase') { return sum.lines[i].tier; }
    }
    return null;
  }
  /* Sep 30: while a tap is still being saved, the message always follows
     the cart the customer EXPECTS (pv), never the older saved copy - the
     saved copy used to repaint the old message until Shopify answered. */
  var pv = null, pvAt = 0;
  function livePv() { return pv && Date.now() - pvAt < 8000 ? pv : null; }
  if (window.ccCart) {
    window.ccCart.onPreview(function (c) {
      pv = c; pvAt = Date.now();
      var sum = summarise(c);
      render(sum, giftTierOf(sum));
    });
    window.ccCart.on(function () { pv = null; check(60000); });
  }

  /* Sep 30: the gift change a cart NEEDS, as /cart/update.js "updates"
     (line key -> 0 to remove, gift variant id -> 1 to add). cc-fast-cart.js
     sends it in the SAME request as the customer's quantity change, so the
     gift swaps with no second round trip. Same rules as check(). */
  window.ccGift = {
    plan: function (cartLike) {
      if (!cartLike || !cartLike.items) { return null; }
      var sum = summarise(cartLike);
      var tier = tierFor(sum.goods);
      var want = tier && !soldOut[tier.tier] && !optedOut(tier) ? tier : null;
      var up = {}, any = false, keep = null;
      sum.lines.forEach(function (l) {
        if (want && l.tier === want.tier && !keep) {
          keep = l;
          if (l.qty !== 1) { up[l.key] = 1; any = true; }
        } else { up[l.key] = 0; any = true; }
      });
      if (want && !keep) { up[String(want.variant)] = 1; any = true; }
      return any ? up : null;
    },
    /* the next gift change seen was made by the cart, not the customer */
    ours: function () { ours = true; }
  };

  function boot() {
    check(0);
    new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var tg = recs[i].target;
        if (tg && tg.closest && tg.closest('.cc-gift')) { continue; }
        /* Sep 29: drawer just redrawn without our box - paint it in this same
           frame from the current cart (display only; decisions still run in check). */
        var fc = livePv() || (window.ccCart && window.ccCart.fresh && window.ccCart.fresh());
        if (fc && anchor()) {
          var b = document.querySelector('.cc-gift');
          if (!b || b.offsetParent === null) { var s = summarise(fc); render(s, giftTierOf(s)); }
        }
        schedule(); return;
      }
    }).observe(document.body, { childList: true, subtree: true });
    /* Safety net only while a cart is actually on screen (it used to
       download the cart every 4 s on every page, cart open or not). */
    setInterval(function () { if (!document.hidden && anchor()) { check(15000); } }, 4000);
    window.addEventListener('pageshow', function () { check(0); });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
}());
